<template>
  <div id="app">
    <div class="navbar">
      <div class="navbar-item item1"><a href="/"><img src="data:image/png;base64,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" class="navbar-logo"></a>
      </div>
      <div class="navbar-item item2">
      </div>
     <div class="navbar-item item3">
        <a href="/payment/index" class="navbar-item-container last-item nav-link">遊戲儲值</a>
        <a href="/register" class="navbar-item-container last-item nav-link">會員註冊</a> 
        <a href="/recovery" class="navbar-item-container last-item nav-link">找回密碼</a> 
        <a href="/modify" class="navbar-item-container last-item nav-link">修改密碼</a> 
      </div>
    </div>
      

    <div class="m-content-display">
      <div class="m-router-view">
        <router-view />
      </div>
      <footer-div />
    </div>
  </div>
</template>

<script>
  import FooterDiv from "@/components/FooterDiv.vue";
export default {
  components: {
    FooterDiv
  },
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  color: #2c3e50;
  display: block;
}

a:link {text-decoration:none;} 
a:active{text-decoration:none;}
a:visited {text-decoration:none;}
a:hover {text-decoration:none;}
.navbar {
    max-width: 1277px;
    width: 100%;
    margin: auto;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
}
.navbar-item {
    display: inline-block;
     line-height: 56px;
}
.item1{ 
  display: flex;
  margin-left: 12px;
  max-width: 409px;
  width: 32.96vw;
}
.item2 {
    max-width: 421px;
    width: 30vw;
    height: 56px;
    overflow: hidden;
    margin-bottom: -20px;
}
.item3 {
    max-width: 435px;
    width: 30vw;
    margin-bottom: -23px;
}
.nav-link {
    color: #575757;
    width: 70px;
    font-size: 13px;
    text-decoration: none;
}
.last-item {
    float: right;
}
.m-content-display {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.m-router-view {
  flex: 1;
}
.footer {
  background-color: #222426;
  height: 400px;
  color: #f1f1f1;
  font-size: 14px;
  font-family: Noto Sans KR, sans-serif;
  font-weight: 400;
}
.footer-container {
    padding-left: 12px;
    max-width: 1269px;
    margin: auto;
    padding-top: 40px;
    color: #f1f1f1;
}
.link-container {
    
    max-width: 960px;
   border-bottom: 1px solid #5a5a5a;  
}
.link-items {
  display: inline-flex;
}

.footer-link {
  margin-right:15px;
  padding-right:14px;
  line-height: 13px;
  font-size: 13px;
  font-weight: 500;
  color: #f1f1f1;
  margin-bottom:10px;
  border-right: 1px solid #5a5a5a;
}

.footer-link-end {
  margin-right:15px;
  padding-right:14px;
  margin-bottom:10px;
  line-height: 13px;
  color: #f1f1f1;
  font-size: 13px;
}
.footer-copyright {
  color: #b4b4b4;
  font-size: 12px;
  margin-top: 15px;
}
.footer-logo {
  display: flex;
  
}
.footer-logo-my {
  margin-top: 15px;
  display: inline-block;
  padding-right:10px;
}
.footer-logo-items {
  margin-top: 25px;
  display: inline-block;
  filter: invert(100%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue